import { Box } from '@jfs/ui-new'
import Svg, { G, Path } from 'react-native-svg'
export const SodexoIcon = ({ height, width, showBorder }: { height: any; width: any; showBorder: boolean }) => {
  return (
    <Box
      borderColor={showBorder ? 'DISABLED_GREY' : undefined}
      borderWidth={showBorder ? 1 : 0}
      borderRadius={showBorder ? 4 : 0}
      paddingHorizontal={showBorder ? 6 : 0}>
      <Svg width={width} height={height} viewBox="0 0 72.11 22.371">
        <G id="Group_3249" data-name="Group 3249" transform="translate(-558.943 -507.64)">
          <G id="Group_5542" data-name="Group 5542" transform="translate(559 507.798)">
            <Path
              id="Path_562"
              data-name="Path 562"
              d="M1156.886,407.562c.457-.935.89-1.881,1.358-2.815.123.957.256,1.9.39,2.86.923-.312,1.825-.679,2.76-.946-.656.8-1.291,1.625-1.925,2.448.69.545,1.38,1.068,2.059,1.614-.923.1-1.847.145-2.771.222-.033.979-.1,1.97-.156,2.96-.534-.712-1.024-1.447-1.536-2.17-.767.7-1.547,1.4-2.292,2.125.29-1,.578-2,.857-3-.89-.111-1.791-.234-2.682-.356.868-.49,1.747-.99,2.615-1.491-.356-.857-.723-1.7-1.068-2.559.79.389,1.6.723,2.392,1.113Z"
              transform="translate(-1093.278 -404.747)"
              fill="#273896"
              stroke="#273896"
              stroke-width="0.094"
            />
            <Path
              id="Path_563"
              data-name="Path 563"
              d="M874.87,478.614c.779-.067,1.558-.111,2.325-.167q-.834,4.44-1.68,8.858a5.672,5.672,0,0,1-2.014,3.517,6.465,6.465,0,0,1-4.218,1.057,4.685,4.685,0,0,1-3.483-1.547,4.328,4.328,0,0,1-.5-3.917,5.4,5.4,0,0,1,3.138-3.517c1.792-.812,3.806-.679,5.72-.623.234-1.224.479-2.448.712-3.661Z"
              transform="translate(-839.839 -470.076)"
              fill="#273896"
              stroke="#273896"
              stroke-width="0.094"
            />
            <Path
              id="Path_564"
              data-name="Path 564"
              d="M1054.1,492.968a57.555,57.555,0,0,0,6.455-6.621,18.173,18.173,0,0,1-5.008,8.168,16.587,16.587,0,0,1-1.692,1.347,12.663,12.663,0,0,1-6.91,2.292l.056-.044a43.225,43.225,0,0,0,5.564-3.817c.512-.434,1.057-.846,1.535-1.324Z"
              transform="translate(-999.883 -477.097)"
              fill="#ec1c25"
              stroke="#ec1c25"
              stroke-width="0.094"
            />
            <Path
              id="Path_565"
              data-name="Path 565"
              d="M759.437,513.44a6.382,6.382,0,0,1,3.873.645,3.281,3.281,0,0,1,1.614,2.371,5.555,5.555,0,0,1-.979,3.795,6.788,6.788,0,0,1-5.008,2.76,6.365,6.365,0,0,1-3.783-.679,3.275,3.275,0,0,1-1.6-2.47,5.642,5.642,0,0,1,1.268-4.051,6.889,6.889,0,0,1,4.618-2.37Z"
              transform="translate(-741.66 -501.13)"
              fill="#273896"
              stroke="#273896"
              stroke-width="0.094"
            />
            <Path
              id="Path_566"
              data-name="Path 566"
              d="M970.4,515.041a7.173,7.173,0,0,1,5.163-1.814,4.429,4.429,0,0,1,2.816.835,2.347,2.347,0,0,1,.445,2.737,3.583,3.583,0,0,1-1.936,1.58,11.038,11.038,0,0,1-5.831.279,2.8,2.8,0,0,0,1.324,2.748,8.659,8.659,0,0,0,5.008.59l-.056.044a6.888,6.888,0,0,1-5.008.991,4.584,4.584,0,0,1-2.96-1.614,3.517,3.517,0,0,1-.734-2.537,5.6,5.6,0,0,1,1.769-3.839Z"
              transform="translate(-931.089 -500.984)"
              fill="#273896"
              stroke="#273896"
              stroke-width="0.094"
            />
            <Path
              id="Path_567"
              data-name="Path 567"
              d="M1164.862,513.027a7.053,7.053,0,0,1,4.006.434,3.376,3.376,0,0,1,1.948,2.459,5.475,5.475,0,0,1-.879,3.839,6.787,6.787,0,0,1-4.752,2.893,7.052,7.052,0,0,1-3.95-.467,3.369,3.369,0,0,1-1.891-2.337,5.38,5.38,0,0,1,.69-3.672,6.715,6.715,0,0,1,4.83-3.149Z"
              transform="translate(-1098.884 -500.717)"
              fill="#273896"
              stroke="#273896"
              stroke-width="0.094"
            />
            <Path
              id="Path_568"
              data-name="Path 568"
              d="M658.865,514.617a11.571,11.571,0,0,1,3.149-.378,19.324,19.324,0,0,1,3.494.267c-.167.445-.334.879-.479,1.324a16.867,16.867,0,0,0-5.019.145c-.5.134-1.146.334-1.28.924-.022.445.389.7.768.812a21.177,21.177,0,0,1,3.561.8,1.744,1.744,0,0,1,1.057,1.269,3.1,3.1,0,0,1-.745,2.571,4.99,4.99,0,0,1-2.8,1.313,15.724,15.724,0,0,1-6.321-.367c.111-.467.245-.935.356-1.4a16.311,16.311,0,0,0,5.353.134c.668-.145,1.424-.5,1.547-1.246.134-.49-.3-.879-.723-1-1.124-.345-2.326-.267-3.427-.679a1.81,1.81,0,0,1-1.124-.99,2.3,2.3,0,0,1,.645-2.47,5.081,5.081,0,0,1,1.992-1.024Z"
              transform="translate(-654.247 -501.884)"
              fill="#273896"
              stroke="#273896"
              stroke-width="0.094"
            />
            <Path
              id="Path_569"
              data-name="Path 569"
              d="M1066.547,514.247c.723,0,1.457.011,2.181,0a44.719,44.719,0,0,0,2.849,3.461l-.056.056c-.478.478-1.024.89-1.535,1.324a47.5,47.5,0,0,1-3.439-4.841Z"
              transform="translate(-1017.617 -501.941)"
              fill="#273896"
              stroke="#273896"
              stroke-width="0.094"
            />
            <Path
              id="Path_570"
              data-name="Path 570"
              d="M889.266,526.947a7.343,7.343,0,0,1,4.206-.5c-.256,1.179-.478,2.359-.723,3.528a3.465,3.465,0,0,1-.99,2.025,3.334,3.334,0,0,1-2.671.69,1.974,1.974,0,0,1-1.636-.979,3.19,3.19,0,0,1-.056-2.27,3.776,3.776,0,0,1,1.87-2.493Z"
              transform="translate(-859.533 -512.656)"
              fill="#fff"
              stroke="#fff"
              stroke-width="0.094"
            />
            <Path
              id="Path_571"
              data-name="Path 571"
              d="M995.572,526.679a3.935,3.935,0,0,1,2.571-.278,1.006,1.006,0,0,1,.79.879,1.472,1.472,0,0,1-1.113,1.458,8.95,8.95,0,0,1-4.273.111,4.194,4.194,0,0,1,2.025-2.17Z"
              transform="translate(-953.265 -512.65)"
              fill="#fff"
              stroke="#fff"
              stroke-width="0.094"
            />
            <Path
              id="Path_572"
              data-name="Path 572"
              d="M779.547,527.949a2.922,2.922,0,0,1,2.515.445,2.338,2.338,0,0,1,.668,2.036,4.6,4.6,0,0,1-.924,2.3,3.81,3.81,0,0,1-3.094,1.458,2.438,2.438,0,0,1-1.792-.634,1.913,1.913,0,0,1-.5-1.246,4.319,4.319,0,0,1,3.127-4.362Z"
              transform="translate(-761.899 -513.981)"
              fill="#fff"
              stroke="#fff"
              stroke-width="0.094"
            />
            <Path
              id="Path_573"
              data-name="Path 573"
              d="M1185.814,527.786a2.989,2.989,0,0,1,2.4.367,2.125,2.125,0,0,1,.812,1.692,4.28,4.28,0,0,1-2.514,4,3.787,3.787,0,0,1-2.794.055,1.785,1.785,0,0,1-1.1-1.5,4.368,4.368,0,0,1,3.193-4.607Z"
              transform="translate(-1119.635 -513.841)"
              fill="#fff"
              stroke="#fff"
              stroke-width="0.094"
            />
            <Path
              id="Path_574"
              data-name="Path 574"
              d="M1109.047,561.094a16.57,16.57,0,0,0,1.691-1.347c1.369,1.5,2.76,2.982,4.151,4.462-.968-.022-1.947.011-2.916-.011a4,4,0,0,1-.634-.59c-.8-.812-1.58-1.636-2.292-2.515Z"
              transform="translate(-1055.029 -542.329)"
              fill="#273896"
              stroke="#273896"
              stroke-width="0.094"
            />
          </G>
        </G>
      </Svg>
    </Box>
  )
}
